import type { IndustryContent } from '@/types/content';
import { getTestimonialsByIndustry } from '../testimonials';

export const plumbingContent: IndustryContent = {
  slug: 'plumbing',
  name: 'Plumbing',
  headline: 'The Operating System for Plumbing Companies',
  subheadline:
    'Handle emergency calls, track permits, and get paid faster—with software built by people who understand the trades.',
  heroImageUrl: '/images/industries/plumbing-hero.webp',
  painPoints: [
    {
      title: 'Emergency calls disrupt everything',
      description:
        "A burst pipe means scrambling to rearrange the entire day's schedule. You need to respond fast without dropping other customers.",
      icon: 'emergency',
    },
    {
      title: 'Permit tracking is a mess',
      description:
        "Which jobs need permits? Which are pending inspection? It's all in spreadsheets and sticky notes.",
      icon: 'permit',
    },
    {
      title: 'Getting paid takes forever',
      description:
        "Invoices go out late, payments come in later. You're chasing checks instead of running your business.",
      icon: 'money',
    },
    {
      title: 'No visibility into job profitability',
      description:
        "You're busy, but are you profitable? Material costs, labor hours, and margins are a mystery until month-end.",
      icon: 'chart',
    },
  ],
  features: [
    {
      title: 'Priority Dispatch',
      description:
        'Emergency jobs slot into the schedule without blowing up the day. Customers see real-time ETAs.',
      icon: 'priority',
    },
    {
      title: 'Permit Management',
      description:
        'Track permit status, inspection dates, and required documentation. Get alerts before deadlines.',
      icon: 'permit',
    },
    {
      title: 'On-Site Payments',
      description:
        'Collect credit cards, checks, or ACH on the spot. Invoice from the truck and get paid same-day.',
      icon: 'payment',
    },
    {
      title: 'Job Costing',
      description:
        'Track materials, labor, and overhead by job. Know your margins before the truck rolls.',
      icon: 'calculator',
    },
    {
      title: 'Customer Portal',
      description:
        'Customers approve estimates, pay invoices, and request service online. Less phone tag for everyone.',
      icon: 'portal',
    },
    {
      title: 'Service History',
      description:
        "See every call, every repair, every note for each customer. Your team never shows up blind.",
      icon: 'history',
    },
  ],
  testimonial: getTestimonialsByIndustry('plumbing')[0],
  stats: [
    { label: 'Faster Payment Collection', value: '2x' },
    { label: 'Permit Compliance Rate', value: '99%' },
    { label: 'Emergency Response Time', value: '-40%' },
    { label: 'Invoice Accuracy', value: '100%' },
  ],
  seo: {
    title: 'Plumbing Business Software | Scheduling & Invoicing | Omniforge',
    description:
      'Plumbing software that handles emergency dispatch, permit tracking, and on-site payments. Built for service plumbers.',
    keywords: [
      'plumbing business software',
      'plumber scheduling software',
      'plumbing dispatch software',
      'plumbing service software',
      'plumber management software',
    ],
  },
};
